import { instance } from './instance'

export const printerService = {
  // Drucker-Einstellungen abrufen
  getPrinterSettings() {
    return instance.get('/RestaurantSettings/printer')
  },

  // Drucker-Einstellungen speichern
  updatePrinterSettings(settings) {
    return instance.put('/RestaurantSettings/printer', settings)
  },

  // Drucker testen
  testPrinter() {
    return instance.post('/orders/test-printer')
  },

  // Bon für spezifische Bestellung drucken
  printOrderReceipt(orderId) {
    return instance.post(`/orders/${orderId}/print-receipt`)
  }
} 